import { render, staticRenderFns } from "./Leftbar.vue?vue&type=template&id=9299b2ba"
import script from "./Leftbar.vue?vue&type=script&lang=js"
export * from "./Leftbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports